import { Component } from '@angular/core';
import { UrlEnvService } from '../../common/services/url-env.service';

@Component({
  selector: 'stats-dashboard',
  templateUrl: './stats-dashboard.component.html',
  styleUrls: ['./stats-dashboard.component.scss']
})
export class StatsDashboardComponent {
  statsUrl:string
  
  constructor(private urlEnvService: UrlEnvService) {
    this.statsUrl = this.urlEnvService.getStatsUrl();
  }

  goToStatsTable(table) {
    window.open(`${this.statsUrl}${table}`, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/stats-dashboard/stats-dashboard.component.ts